var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.004,
    cy: 11.9337,
    r: 3.3634,
    fill: "white",
    stroke: "#313131",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 15.2969C12.9092 15.2969 11.0855 16.3654 10.122 17.9494C9.34313 19.2298 10.6095 20.5288 12.1082 20.5288H17.8922C19.3909 20.5288 20.6573 19.2298 19.8784 17.9494C18.9148 16.3654 17.0912 15.2969 15.0002 15.2969Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 15.2969C12.9092 15.2969 11.0855 16.3654 10.122 17.9494C9.34313 19.2298 10.6095 20.5288 12.1082 20.5288H17.8922C19.3909 20.5288 20.6573 19.2298 19.8784 17.9494C18.9148 16.3654 17.0912 15.2969 15.0002 15.2969Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.3,
    stroke: "#313131",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortIcon);
export default __webpack_public_path__ + "static/media/cohort-icon.9c44d0b3ff02008e6effe24ac40f1774.svg";
export { ForwardRef as ReactComponent };